//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { server } from "@/services/constants";
import api from "@/services/api";
import {
  getIncorporateDocketPagination,
  deleteIncorporateDocket,
} from "@/services/api-dtime/api_incorporate";

export default {
  name: "incorporate-docket-list",
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      tableLoading: false,
      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      mDataArray2: [],

      search: "",
      search_status: "",
      search_doc_category: "",

      status_list: [
        // { name: "In Progress", value: "In Progress" },
        // { name: "Complete", value: "Complete" },
        // { name: "Request Payment", value: "Request Payment" },
        // { name: "Cancelled", value: "Cancelled" },
      ],
      doc_category_list: [
        { name: "Company Incorporation Documents | เอกสารตั้งบริษัท", value: "Company Incorporation Documents | เอกสารตั้งบริษัท" },
        { name: "Certified Copy + Registration Items + Application", value: "Certified Copy + Registration Items + Application" },
        { name: "Memorandum of Association | บช.บริคณห์สนธิ", value: "Memorandum of Association | บช.บริคณห์สนธิ" },
        { name: "Articles of Association | ข้อบังคับ", value: "Articles of Association | ข้อบังคับ" },
        { name: "List of Shareholders (Form BorJor.5) | บัญชีรายชื่อผู้ถือหุ้น", value: "List of Shareholders (Form BorJor.5) | บัญชีรายชื่อผู้ถือหุ้น" },
        { name: "Financial Statement Submission Forms (SorBorChor.3)", value: "Financial Statement Submission Forms (SorBorChor.3)" },
        { name: "Tax Information | ข้อมูลภาษี", value: "Tax Information | ข้อมูลภาษี" },
        { name: "Share Certificates / Share Register | ใบหุ้น/ทะเบียนหุ้น", value: "Share Certificates / Share Register | ใบหุ้น/ทะเบียนหุ้น" },
        { name: "Minutes of Board of Directors' Meeting", value: "Minutes of Board of Directors' Meeting" },
        { name: "Minutes of Extraordinary Shareholders' Meeting", value: "Minutes of Extraordinary Shareholders' Meeting" },
        { name: "Minutes of Annual General Shareholders' Meeting", value: "Minutes of Annual General Shareholders' Meeting" },
        { name: "BOI Documents / Promotion Certificate", value: "BOI Documents / Promotion Certificate" },
        { name: "Various Licenses / Permits | ใบอนุญาตต่าง ๆ", value: "Various Licenses / Permits | ใบอนุญาตต่าง ๆ" },
        { name: "Agreements / Contracts | สัญญาต่าง ๆ", value: "Agreements / Contracts | สัญญาต่าง ๆ" },
        { name: "Legal Opinion | ความเห็นทางกฎหมาย", value: "Legal Opinion | ความเห็นทางกฎหมาย" },
        { name: "Work Rules | ข้อบังคับการทำงาน", value: "Work Rules | ข้อบังคับการทำงาน" },
        { name: "Due Diligence Report", value: "Due Diligence Report" },
        { name: "Others | อื่น ๆ", value: "Others | อื่น ๆ" },
      ],
      dialogDelete: false,
      dialogAdd: false,
      dialogAddPush: false,
      text_color: "text-h5 green--text text-center",
      title: "",
      message: "",
      link: "",
      id_del: 0,

      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: "",
      userId: "",

      headers: [
        {
          text: "Client Name | ชื่อลูกค้า",
          value: "client_name",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "180px",
        },
        {
          text: "Inquiry Topic | Document Category",
          value: "inquiry_topic",
          class: "bg-colorth tabletextwhite",
          divider: true,
        },
        {
          text: "Change Tracker | การเปลี่ยนแปลง",
          value: "change_tracker",
          class: "bg-colorth tabletextwhite",
          divider: true,
          width: "140px",
        },
        {
          text: "Date Received | วันที่รับเรื่อง",
          value: "date_received",
          class: "bg-colorth tabletextwhite",
          align: "center",
          divider: true,
          width: "130px",
        },
        {
          text: "Date Submitted | วันที่ส่งคำขอ",
          value: "date_submitted",
          class: "bg-colorth tabletextwhite",
          align: "center",
          divider: true,
          width: "130px",
        },
        {
          text: "Quotation",
          value: "doc_no",
          class: "bg-colorth tabletextwhite",
          align: "start",
          divider: true,
          width: "145px",
        },
        {
          text: "Invoice",
          value: "inv_h_inv_id",
          class: "bg-colorth tabletextwhite",
          align: "start",
          divider: true,
          width: "130px",
        },
        {
          text: "Status",
          value: "status",
          class: "bg-colorth tabletextwhite",
          align: "center",
          divider: true,
          width: "140px",
        },
        {
          text: "Action",
          value: "actions",
          class: "bg-colorth tabletextwhite",
          align: "center",
          sortable: false,
          divider: true,
          width: "80px",
        },
      ],
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader();
    this.userId = localStorage.getItem(server.USER_ID);
    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    if (!this.authorize_id || this.authorize_id == 0) {
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
      return;
    }

    let parser = document.createElement("a");
    parser.href = window.location;
    const router_path = parser.pathname.replace("/", "");
    const { default: api } = await import("@/services/api");
    const res_auth = await api.getAuthorize(this.userId, router_path);
    this.authorize_view = res_auth.data[0].smd_view >= 1;
    this.authorize_add = res_auth.data[0].smd_add >= 1;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1;
    this.authorize_del = res_auth.data[0].smd_del >= 1;

    if (!this.authorize_view) {
      this.$router.back();
      return;
    }

    await this.loaddataLitigationCourtStatus();
    await this.onSearchPagination();
  },
  methods: {
    async loaddataLitigationCourtStatus() {
      const result = await api.getClientTimelineStatusCongFigByModule("Corporate");
      this.status_list = (result.data || []).map(item => ({
        ...item,
        module_id: item.module_id
      }));
      console.log(this.status_list)

    },
    getDocketStatusColor(status) {
      const map = {
        "In Progress": "blue lighten-4",
        Complete: "green lighten-4",
        "Request Payment": "pink lighten-4",
        Cancelled: "red lighten-4",
      };
      return map[status] || "grey lighten-3";
    },
    splitList(str) {
      if (!str) return [];
      return str
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
    getDocketStatusTextColor(status) {
      const map = {
        "In Progress": "blue darken-2",
        Complete: "green darken-2",
        "Request Payment": "pink darken-2",
        Cancelled: "red darken-2",
      };
      return map[status] || "grey darken-1";
    },

    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      try {
        const company_id = localStorage.getItem(server.COMPANYID);
        const res = await getIncorporateDocketPagination(
          pageNumber,
          this.itemsPerPage,
          "id",
          "DESC",
          company_id,
          this.search,
          this.search_status,
          this.search_doc_category,
        );
        this.mDataArray2 = res.data.data;
        this.totalItems = res.data.pagination.totalRecords;
        this.page = res.data.pagination.currentPage;
        this.pageCount = res.data.pagination.totalPages;

      } catch (error) {
        console.error("Error loading dockets:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async onSearchPagination() {
      this.page = 1;
      this.tableLoading = true;
      try {
        const company_id = localStorage.getItem(server.COMPANYID);
        const res = await getIncorporateDocketPagination(
          1,
          this.itemsPerPage,
          "id",
          "DESC",
          company_id,
          this.search,
          this.search_status,
          this.search_doc_category,
        );
        this.mDataArray2 = res.data.data;
        this.totalItems = res.data.pagination.totalRecords;
        this.pageCount = res.data.pagination.totalPages;
        console.log(this.mDataArray2)
      } catch (error) {
        console.error("Error searching dockets:", error);
        this.mDataArray2 = [];
        this.totalItems = 0;
        this.pageCount = 0;
      } finally {
        this.tableLoading = false;
      }
    },

    deleteItem(id) {
      this.id_del = id;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        await deleteIncorporateDocket(this.id_del);
        this.setupAlertDialog(
          true,
          "Success",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
        );
        await this.onSearchPagination();
      } catch (error) {
        console.error("Error deleting docket:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถลบข้อมูลได้",
          "text-h5 red--text text-center",
        );
      }
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.id_del = 0;
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
